import { MenuItem, Skeleton } from '@mui/material'
import React from 'react'

export default function NotificationListItemSkeleton({ menuItemRef }) {
  return (
    <MenuItem disabled ref={menuItemRef}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          flexDirection: 'column',
          width: '100%',
          // padding: '0px 10px',
        }}
      >
        <Skeleton
          sx={{ maxWidth: '190px', width: '100%', backgroundColor: '#00000070' }}
        ></Skeleton>
        <Skeleton sx={{ width: '100%', backgroundColor: '#00000070' }}></Skeleton>
      </div>
    </MenuItem>
  )
}
